import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { CedarTreeIcon } from './icons/CedarTreeIcon';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Announcements',
    href: '#announcements'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About & Contact',
    href: '#about'
  }];
  const closeMenu = () => setIsMobileMenuOpen(false);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md transition-all duration-300" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-164">
        {/* Logo & Title — left aligned */}
        <a href="#home" className="flex items-center gap-3 group shrink-0" onClick={closeMenu} data-id="element-165">
          <div className="w-11 h-11 bg-emerald-50 rounded-full flex items-center justify-center group-hover:bg-emerald-100 transition-colors shrink-0" data-id="element-166">
            <CedarTreeIcon className="w-7 h-7 text-[#00a850] transition-transform group-hover:scale-105" data-id="element-167" />
          </div>
          <div className="flex flex-col" data-id="element-168">
            <span className="font-serif font-bold text-base sm:text-lg md:text-xl text-foreground leading-tight" data-id="element-169">
              Consulate General of Lebanon
            </span>
            <span className="text-[11px] sm:text-xs text-muted-foreground uppercase tracking-[0.2em] font-medium" data-id="element-170">
              Sydney, Australia
            </span>
          </div>
        </a>

        {/* Desktop Navigation — right aligned */}
        <nav className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-171">
          {navLinks.map(link => <a key={link.name} href={link.href} className="relative text-sm font-semibold text-foreground/70 hover:text-foreground transition-colors py-2 group whitespace-nowrap" data-id="element-172">
              {link.name}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00a850] transition-all duration-300 group-hover:w-full rounded-full" data-id="element-173"></span>
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden p-2 text-foreground hover:bg-muted rounded-md transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded={isMobileMenuOpen} aria-label="Toggle navigation menu" data-id="element-174">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-175" /> : <MenuIcon className="w-6 h-6" data-id="element-176" />}
        </button>
      </div>

      {/* Lebanese Flag Stripe — red / white / green / white / red */}
      <div className="h-1 w-full flex" data-id="element-177">
        <div className="h-full w-1/5 bg-[#ED1C24]" data-id="element-178"></div>
        <div className="h-full w-1/5 bg-[#f0f0f0]" data-id="element-179"></div>
        <div className="h-full w-1/5 bg-[#00a850]" data-id="element-180"></div>
        <div className="h-full w-1/5 bg-[#f0f0f0]" data-id="element-181"></div>
        <div className="h-full w-1/5 bg-[#ED1C24]" data-id="element-182"></div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <nav className="lg:hidden bg-white border-t border-border shadow-xl absolute w-full left-0" data-id="element-183">
          <ul className="flex flex-col py-2" data-id="element-184">
            {navLinks.map(link => <li key={link.name} data-id="element-185">
                <a href={link.href} className="block px-6 py-4 text-base font-semibold text-foreground hover:bg-emerald-50 hover:text-[#00a850] transition-colors border-b border-border/40" onClick={closeMenu} data-id="element-186">
                  {link.name}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}